import { InjectionToken } from '@angular/core';

/**
 * Used to provide a parser that can be used with the MarkdownService
 * to parse markdown input into HTML
 */
export const MARKDOWN_PROVIDER = new InjectionToken<MarkdownParseFn>('MARKDOWN_PROVIDER');
export type MarkdownParseFn = (input: string, options?: any) => string;
